import React, {Fragment, useEffect, useState} from 'react'
import {Dialog, Transition} from '@headlessui/react'
import GameAnalysisPage from "../../pages/GameAnalysisPage";
import {RiCloseLine} from "react-icons/ri";
import {accountInfo} from "../../constants/constants";

const GameAnalysisModal = ({
                             analysisType,
                             gameId,
                             setGameId,
                             showGameAnalysisModal,
                             setShowGameAnalysisModal
                           }) => {
  const [open, setOpen] = useState(true);
  const [modalHomeTeamName, setModalHomeTeamName] = useState(null);
  const [modalAwayTeamName, setModalAwayTeamName] = useState(null);

  useEffect(() => {
    if (showGameAnalysisModal) {
      // 모달 열릴 때 가짜 히스토리 상태 추가
      window.history.pushState(null, "", window.location.href);
    }

    const handlePopState = () => {
      if (showGameAnalysisModal) {
        closeModal(); // 뒤로가기 시 모달 닫기
      }
    };

    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [showGameAnalysisModal]);

  const closeModal = () => {
    setOpen(false);
    setShowGameAnalysisModal(false);
    setGameId(null);
  }

  if (!showGameAnalysisModal) return null;

  return (
      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="fixed inset-0 z-60 flex items-center justify-center overflow-y-auto"
                onClose={closeModal}>
          <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"/>
          </Transition.Child>

          <div className="flex w-full items-center justify-center">
            <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel
                  className="w-full max-w-lg lg:max-w-[50rem] relative transform rounded-lg bg-white shadow-xl h-screen overflow-y-scroll"
              >
                {/* 팀이름 정보 */}
                <div className="flex flex-row justify-between items-center px-4 py-2 border-b pt-5 sticky top-0 z-20 bg-white shadow-md">
                  <div className="flex-1 flex justify-center items-center space-x-4">
                    <span
                        className="bg-red-600 text-white rounded-full min-w-24 text-center py-0.5 text-lg font-bold px-2">
                      {modalHomeTeamName}
                    </span>
                    <span className="text-lg font-bold">VS</span>
                    <span
                        className="bg-blue-600 text-white rounded-full min-w-24 text-center py-0.5 text-lg font-bold px-2">
                      {modalAwayTeamName}
                    </span>

                    {accountInfo.isDeveloper() && <span className="text-sm text-gray-500">{gameId}</span>}
                  </div>

                  <button onClick={closeModal} className="ml-auto">
                    <RiCloseLine className="w-6 h-6"/>
                  </button>
                </div>

                {/* 분석 페이지 */}
                <div className="px-2">
                  <GameAnalysisPage analysisType={analysisType}
                                    gameId={gameId}
                                    setModalHomeTeamName={setModalHomeTeamName}
                                    setModalAwayTeamName={setModalAwayTeamName}
                  />
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
  )
}
export default GameAnalysisModal;